"use client";

import Link from "@/components/no-prefetch-link";
import { useEffect, useRef, type ReactNode } from "react";
import { trackProductEvent } from "@/lib/analytics-events";

export function SearchResultLink({
  href,
  query,
  topicName,
  position,
  total,
  exactMatch,
  className,
  children,
}: {
  href: string;
  query: string;
  topicName: string;
  position: number;
  total: number;
  exactMatch: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() => trackProductEvent("search_result_click", {
        search_term: query,
        topic_name: topicName,
        result_position: position,
        result_count: total,
        exact_match: exactMatch,
        entry_source: "search_results",
        content_type: "topic",
      })}
    >
      {children}
    </Link>
  );
}

export function SearchNoResultsEvent({ query }: { query: string }) {
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    trackProductEvent("search_no_results", {
      search_term: query,
      entry_source: "search_page",
      content_type: "topic",
    });
  }, [query]);

  return null;
}
